import dayjs from 'dayjs';

export const isStandbyOpen = (departureDateTime: Date, hoursBeforeDeparture: number): boolean => {
	const departureTime = dayjs(departureDateTime);
	const standbyOpenTime = departureTime.subtract(hoursBeforeDeparture, 'hours');
	return dayjs().isAfter(standbyOpenTime);
};
